// This is just for the Loading or Error Selector
export const GET_PRINTERS = 'GET_PRINTERS';

// Use these for Actions
export const GET_PRINTERS_REQUEST = 'GET_PRINTERS_REQUEST';
export const GET_PRINTERS_SUCCESS = 'GET_PRINTERS_SUCCESS';
export const GET_PRINTERS_ERROR = 'GET_PRINTERS_ERROR';
